var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAccessIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  className: "access-icon_svg__sc-tag3-icon-svg",
  style: {
    height: "inherit",
    width: "inherit",
    fill: "#e5173f"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m23 11.5-7.13-6.375A8.228 8.228 0 0 0 10.347 3 8.425 8.425 0 0 0 2 11.5a8.426 8.426 0 0 0 8.347 8.5 8.221 8.221 0 0 0 5.521-2.126L23 11.5m-18.465 0a5.868 5.868 0 0 1 5.814-5.92 5.921 5.921 0 0 1 0 11.839A5.868 5.868 0 0 1 4.533 11.5Z",
  className: "access-icon_svg__sc-tag3-icon-svg"
})));
export default SvgAccessIcon;